export const CSS_VAR_ROUTER_TRANSITION_DURATION = "router-transition-duration";
export const CSS_VAR_COLOR_HOLDER_MOVE_DURATION = "color-holder-move-duration";

export const PLAYER_NAME_LENGTH_LIMIT = 24;
